import { render, staticRenderFns } from "./m-header.vue?vue&type=template&id=15777945&"
import script from "./m-header.vue?vue&type=script&lang=js&"
export * from "./m-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports